import React, { useEffect, useState } from 'react';
import { Link } from "react-router";
import BlogSmallCard from "./BlogSmallCard";

const API_HOST = process.env.REACT_APP_API_URL;
const BlogSection = () => {
    const [blogs, setBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    // Fetch blogs on mount using fetch
  useEffect(() => {
    fetch(`${API_HOST}blogs/latest-priority-blogs`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log("BlogSection API Response:", data); // Log the API response
        // Ensure each blog has a creator field
        const blogsWithCreator = data.map(blog => {
          console.log("BlogSection Blog creator before:", blog.creator); // Log each blog's creator
          const updatedBlog = {
            ...blog,
            creator: blog.creator === 'creator' || !blog.creator ? 'Admin' : blog.creator
          };
          console.log("BlogSection Blog creator after:", updatedBlog.creator); // Log the updated creator
          return updatedBlog;
        });
        console.log("BlogSection Final blogs array:", blogsWithCreator); // Log the final array
        setBlogs(blogsWithCreator);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching blogs:', error);
        setLoading(false);
      });
  }, []);

  // While fetching, show a loading indicator or skeleton cards
//   if (loading) {
//     return <p>Loading blogs...</p>; 
//   }

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
  };

  // Helper: Truncate title to 8-9 words
  const truncateTitle = (title) => {
    const words = title.split(' ');
    return words.length > 9 ? words.slice(0, 9).join(' ') + '...' : title;
  };



  const extractParagraphs = (contentBlocks) => {
    if (!Array.isArray(contentBlocks)) return '';
  
    // Extract paragraph text
    let text = contentBlocks
      .filter(block => block.type === 'paragraph')
      .map(block => block.data?.text || '')
      .join(' ');
  
    // Clean up unwanted [object Object] and JSON blobs
    text = text.replace(/\[object Object\]/g, '').replace(/\{.*?\}/g, '');
  
    // Truncate to 25 words
    const words = text.split(' ');
    return words.length > 25 ? words.slice(0, 25).join(' ') + '...' : text;
  };
  
  return (
    <>
      <section className="blog pt-135 pb-150">
        <div className="container">
          <div className="row align-items-end mb-10">
            <div className="col-lg-8">
              <div className="section-title mb-30">
                <span
                  className="sub-title wow fadeInRight"
                  data-wow-duration=".7s"
                >
                  Blog & Article
                </span>
                <h3 className="title xb-split-text split-in-right">
                  Explore Blogs & <br /> <span>articles</span>
                </h3>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="faq-btn ul_li_right mb-30">
                <Link to="/blogs" className="btn-link ul_li_right">
                  See All Blogs{" "}
                  <span>
                    <img src="assets/img/icon/arrow-right2.svg" alt="" />
                  </span>
                </Link>
              </div>
            </div>
          </div>


          {blogs.map((blog, index) => (
        <BlogSmallCard
          key={blog._id || index}
          title={truncateTitle(blog.title)}
          content={extractParagraphs(blog.content)}
          date={formatDate(blog.date)}
          urlHeading={blog.urlHeading}
          homeImage={blog.homeImage}
          creator={blog.creator}
        />
      ))}

           
        </div>
      </section>
    </>
  );
};

export default BlogSection;
